/** @jsx CanvaSX */
import { CanvaSX, renderElement, withContext } from '@lib/canvasx/canvasx';
import { FlexRow } from '@lib/canvasx/components/FlexRow';
import { FlexColumn } from '@lib/canvasx/components/FlexColumn';
import { Rect } from '@lib/canvasx/components/Rect';
import { Text } from '@lib/canvasx/components/Text';
import type ShapeSmartRecord from '../../shapes/ShapeSmartRecord';
import { RecordIcons } from '../../shapes/RecordIcons';
import { SPACER_1, SPACER_2, SPACER_3 } from '../../utils/style';
import { canvasCssValue } from '@lib/canvasx/util';

const PILL_MARGIN_LEFT = SPACER_3;
const PILL_PADDING = SPACER_1;
const PILL_GAP = SPACER_1;
// Rough estimate of the icon size
const ICON_SIZE = 32;

// This is a bit of a workaround for rendering react and csx in the same file.
// Pragma switching withing a ShapeBase subclass doesn't seem to work. It may
// have something to do with the context in which those functions are called.
const renderRecordName = (
  ctx: CanvasRenderingContext2D,
  shape: ShapeSmartRecord
) => {
  const { scaleX, scaleY, width, height } = shape.fabricObject;

  const x = -width / 2;
  const y = -height / 2;

  const recordTypename = shape.recordTypename ?? 'Feature';
  const Icon = RecordIcons[recordTypename];

  const maxPillWidth =
    shape.fabricObject.getScaledWidth() -
    PILL_MARGIN_LEFT -
    PILL_GAP -
    ICON_SIZE -
    PILL_PADDING * 2;

  ctx.save();
  ctx.translate(x, y);
  withContext(
    {
      canvas: shape.fabricObject.canvas,
      ctx,
      object: shape.fabricObject,
      scale: 1,
    },
    () => {
      ctx.scale(1 / scaleX, 1 / scaleY);
      renderElement(
        <FlexColumn
          padding={{
            top: SPACER_2,
            left: PILL_MARGIN_LEFT,
            right: 0,
            bottom: 8,
          }}
        >
          <FlexRow
            fill={shape.pillBackgroundColor}
            padding={PILL_PADDING}
            borderRadius={48}
            verticalAlignment='center'
            gap={SPACER_1}
            height={22}
          >
            <Rect
              fill={canvasCssValue(shape.recordColor, '#ffffff')}
              padding={3}
              borderRadius={SPACER_3}
            >
              <Icon size={8} color='white' />
            </Rect>
            <Rect padding={{ right: 2, top: 2 }}>
              <Text maxWidth={maxPillWidth} size={12} overflow='…'>
                {shape.terminologyName}
              </Text>
            </Rect>
          </FlexRow>
        </FlexColumn>
      );
    }
  );
  ctx.restore();
};

export default renderRecordName;
